// extracted by mini-css-extract-plugin
module.exports = {"s360ott":"s360ott","i1df5wci":"i1df5wci","l1fyq1q5":"l1fyq1q5"};